import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import EntryPoint from "../../../engine/src/EntryPoint";

export default new class ErrorsManager {
    constructor() {
        this.init();
        this.addListeners();
    }

    init() {

    }

    addListeners() {

    }

    getError(data) {
        let popupData = {
            data: data,
            type: 'error'
        };
        EntryPoint.PostMessages && EntryPoint.PostMessages.onErrorMessage(data);
        GlobalDispatcher.dispatch('popupContainer:showPopup', popupData);
    }
}